export default __webpack_public_path__ + "static/media/alex.8f8f593c.jpg";